import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useQuery } from 'react-query';
import { getFirebase } from 'react-redux-firebase';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';
import _isNumber from 'lodash/isNumber';

const useStyles = makeStyles({
  wrapper: {
    backgroundColor: '#F9F8F8',
    padding: 8,
  },
  text: {
    textAlign: 'center',
  },
});

const fetchBenchmarkData = async (key, type) => {
  if (type === 'depression' || type === 'anxiety') {
    const snapshot = await getFirebase()
      .firestore()
      .collection('assessment_benchmarks')
      .where('type', '==', type)
      .orderBy('timestamp', 'desc')
      .limit(1)
      .get();
    const data = snapshot.docs.map(doc => doc.data())[0];

    return data;
  }
  return {};
};

export default function BenchmarkSection({ text, type, userData }) {
  const classes = useStyles();
  const { data } = useQuery([`${type}-benchmark`, type], fetchBenchmarkData, {
    retry: 1,
  });

  if (
    _isEmpty(data) ||
    !_isNumber(_get(data, ['age', userData.age])) ||
    !_isNumber(_get(data, ['gender', userData.gender]))
  )
    return null;

  const finalText = text.replace(/<<[^+\s,]+>>/g, m => {
    const key = m.substring(2, m.length - 2);
    if (key === 'benchmarkDate') {
      return data.benchmarkDate;
    }
    if (key === 'percentGender') {
      const dataGender = data.gender[userData.gender];
      if (dataGender) return `${dataGender.toFixed(1)}%`;
      return '';
    }
    if (key === 'percentAge') {
      const dataAge = data.age[userData.age];
      if (dataAge) return `${dataAge.toFixed(1)}%`;
      return '';
    }
    if (key === 'gender') {
      const { gender } = userData;
      return `${gender.toLowerCase()}s`;
    }
    if (key === 'age') {
      const { age } = userData;
      return age.substring(1, age.length - 1);
    }

    return '';
  });

  return (
    <div className={classes.wrapper}>
      <Typography variant="body2" className={classes.text}>
        {finalText}
      </Typography>
    </div>
  );
}

BenchmarkSection.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string,
  userData: PropTypes.shape({
    gender: PropTypes.string,
    age: PropTypes.string,
  }),
};
